import { provide } from 'vue';
import { storeShape } from './PropTypes';
import { getSlot } from '../props-util';
export default {
  name: 'StoreProvider',
  props: {
    store: storeShape.isRequired
  },
  created: function created() {
    provide('storeContext', this.$props);
  },
  render: function render() {
    return getSlot(this);
  }
};